import comp from "./NewProductUpdatesCallout";
export default comp;
